@if (loading) {
  <div class="text-center" style="width: 300px; position: absolute; height: 50vh; top: 45%">
    <mat-spinner style="display: inline-block" diameter="24"></mat-spinner>
  </div>
}

@if (!loading) {
  <div class="email-list ag-ma-md">
    <h4>Send Email</h4>
    <form (ngSubmit)="validSendEmail(emailForm)" [formGroup]="emailForm">
      <h6>FROM</h6>
      <div class="form-group">
        <input
          type="text"
          title="From"
          class="form-control"
          id="FromAddressName"
          formControlName="FromAddressName"
          aria-describedby="emailHelp"
          placeholder="Enter Name"
        />
      </div>
      <div class="form-group">
        <input
          type="email"
          title="Email"
          class="form-control"
          id="FromAddress"
          formControlName="FromAddress"
          aria-describedby="emailHelp"
          placeholder="Enter Email"
        />
        <small id="FromAddressHelp" class="form-text text-muted"
          >If nothing is sent, then “no-reply&#64;auto-graphics.com” will be the default.</small
        >
      </div>
      <h6>TO</h6>
      <div class="form-group">
        <input
          type="email"
          title="To"
          id="ToAddress"
          aria-describedby="ToAddressHelp"
          placeholder="To: email"
          formControlName="ToAddress"
          [ngClass]="{
            'form-control': true,
            'input-required': emailForm.controls.ToAddress.invalid,
            'input-valid': emailForm.controls.ToAddress.valid
          }"
        />
      </div>
      @if (ccBCC === true) {
        <div class="form-group">
          <input
            type="email"
            title="CC"
            class="form-control"
            id="CCAddress"
            formControlName="CCAddress"
            aria-describedby="CCAddressHelp"
            placeholder="CC: email"
          />
        </div>
      }
      @if (ccBCC === true) {
        <div class="form-group">
          <input
            type="email"
            title="BBC"
            class="form-control"
            id="BCCAddress"
            formControlName="BCCAddress"
            aria-describedby="BCCAddressHelp"
            placeholder="BCC: email"
          />
          <small id="BCCAddressHelp" class="form-text text-muted"
            >Multiple addresses use a comma to separate.</small
          >
        </div>
      }
      <div class="form-group">
        <input
          type="text"
          title="Subject"
          class="form-control"
          id="Subject"
          formControlName="Subject"
          placeholder="Subject"
        />
      </div>
      <div class="form-group">
        <textarea
          class="form-control"
          id="MessageBody"
          formControlName="MessageBody"
          [rows]="row"
          title="Type Message Here"
        ></textarea>
      </div>
      <button
        role="button"
        aria-label="Submit"
        type="submit"
        class="btn btn-primary"
        [disabled]="!emailForm.valid"
      >
        Send
      </button>
    </form>
  </div>
}
<!--

                OUTPUT DEFINITIONS:
                “status” – if True, email was sent successfully. If False, email could not be sent.
                “msg” – brief message about status.

                <pre>
                  {
                  "FromAddress": "no-reply@auto-graphics.com",
                  "FromAddressName": "This Cool Library",
                  "ToAddress": "jps@auto-graphics.com",
                  "CCAddress": "",
                  "BCCAddress": "",
                  "Subject": "Your subject here",
                  "MessageBody": "Your email message here...",
                  "IsBodyHtml": true
                }
              </pre>

              <pre>
                BODY DEFINITIONS:
                “FromAddress” – the email from address. If nothing is sent, then “no-reply@auto-graphics.com” will be the default.
                “FromAddressName” – the display text that will show as the email sender aside from the FromAddress. Example: “Plattville Public Library”. Optional.
                “ToAddress” – the email to address. Multiple addresses can be sent comma separated.
                “CCAddress” – the email cc address. Optional.
                “BCCAddress” – the email bcc address. Optional.
                “Subject” – the subject of the email.
                “MessageBody” – the email message body.
                “IsBodyHtml” – whether the body should be sent as HTML. Default is True. Set to False to send plain text.
              </pre>
              -->
